import React, { useState, useEffect, useCallback } from "react";
import { clearLedgerLink } from "actions/ledgerLinks.action";
import {
    clearMattersBalances,
    clearMattersPostings,
    getMattersInfo,
} from "actions/matters.action";
import MatterLedgerGrid from "components/LedgerGrid";
import { useDispatch, useSelector } from "react-redux";
import * as api from "../../api/index";

export default function MatterLedgerCardPage({
    reference,
    selTab,
    refreshClicked,
    setRefreshClicked,
    activeItem,
}) {
    const dispatch = useDispatch();
    const [showDDA, setShowDDA] = useState(true);
    const [list, setLists] = useState([]);

    const matterDetails = useSelector((state) => state.mattersList);
    const currentMatterId =
        matterDetails.matterViewDetails[selTab]?.data.matterId;

    const onChangeMatter = (matterId) => {
        dispatch(clearMattersPostings());

        if (!matterId) {
            dispatch(clearLedgerLink("Matters", ""));
            setLists([]);
            dispatch(clearMattersBalances("Matter Ledger"));
            return;
        }

        dispatch(getMattersInfo(matterId));
    };

    const apiDataFetcher = useCallback(async (matterId) => {
        if (!matterId) return;
        try {
            const { data } = await api.getMattersPostings(matterId, "ALL"); // only ALL type
            setLists(data.data || []);
        } catch (error) {
            console.error("Failed to fetch matter postings:", error);
            setLists([]);
        }
    }, []);

    useEffect(() => {
        if (currentMatterId) {
            onChangeMatter(currentMatterId);
        }
    }, [currentMatterId]);

    useEffect(() => {
        if (refreshClicked && activeItem === 6) {
            apiDataFetcher(reference);
            setRefreshClicked(false);
        }
    }, [
        refreshClicked,
        activeItem,
        apiDataFetcher,
        reference,
        setRefreshClicked,
    ]);

    useEffect(() => {
        if (reference) {
            apiDataFetcher(reference);
        }
    }, [reference, apiDataFetcher]);

    return (
        <MatterLedgerGrid
            showDDA={showDDA}
            setShowDDA={setShowDDA}
            matterId={reference}
            comp="ledgerCard"
            gridData={list}
        />
    );
}
